import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
export function SignupPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    program: '',
    preferredTime: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Form submission logic will be implemented later
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const cities = ['Grapevine', 'Colleyville', 'Southlake', 'Coppell', 'Euless', 'Irving', 'Bedford', 'Hurst', 'Trophy Club', 'Flower Mound', 'Lewisville', 'North Richland Hills', 'Keller', 'Las Colinas', 'Westlake'];
  return <div className="min-h-screen bg-neutral-50" data-id="element-320">
      {/* Header Section */}
      <section className="bg-neutral-900 text-white py-16 md:py-20" data-id="element-321">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-322">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-323">
            <h1 className="text-4xl md:text-6xl font-black mb-6 tracking-tight" data-id="element-324">
              Easy Class Signup
            </h1>
            <p className="text-xl md:text-2xl font-medium text-gray-300 mb-4" data-id="element-325">
              Get started with Taekwondo classes for kids, teens, and adults in
              Grapevine, Texas.
            </p>
            <p className="text-lg text-gray-400 leading-relaxed max-w-3xl mx-auto" data-id="element-326">
              Signing up is simple. Whether you're looking for a fun and
              structured program for your child or a challenging and rewarding
              martial arts experience for yourself, our Taekwondo classes are
              designed to help students build confidence, discipline, and
              fitness from day one.
            </p>
          </motion.div>
        </div>
      </section>

      {/* What to Expect Section */}
      <section className="py-16 bg-white" data-id="element-327">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-328">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-329">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-330">
              What to Expect When You Sign Up
            </h2>
            <p className="text-lg text-neutral-600 leading-relaxed" data-id="element-331">
              When you sign up, our team will contact you to answer any
              questions and help you choose the right class based on age,
              experience level, and goals. There are no contracts and no
              pressure — just clear information and a welcoming environment.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Signup Form Section */}
      <section className="py-16 bg-neutral-50" data-id="element-332">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-333">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-334">
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-8 text-center" data-id="element-335">
              Sign Up for Classes
            </h2>

            <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-8 md:p-10" data-id="element-336">
              {/* Name Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-337">
                <div data-id="element-338">
                  <label htmlFor="firstName" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-339">
                    First Name <span className="text-red-700" data-id="element-340">*</span>
                  </label>
                  <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900" data-id="element-341" />
                </div>
                <div data-id="element-342">
                  <label htmlFor="lastName" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-343">
                    Last Name <span className="text-red-700" data-id="element-344">*</span>
                  </label>
                  <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900" data-id="element-345" />
                </div>
              </div>

              {/* Email */}
              <div className="mb-6" data-id="element-346">
                <label htmlFor="email" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-347">
                  Email Address <span className="text-red-700" data-id="element-348">*</span>
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900" data-id="element-349" />
              </div>

              {/* Phone */}
              <div className="mb-6" data-id="element-350">
                <label htmlFor="phone" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-351">
                  Phone Number <span className="text-red-700" data-id="element-352">*</span>
                </label>
                <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900" data-id="element-353" />
              </div>

              {/* Program Dropdown */}
              <div className="mb-6" data-id="element-354">
                <label htmlFor="program" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-355">
                  Program of Interest <span className="text-red-700" data-id="element-356">*</span>
                </label>
                <select id="program" name="program" required value={formData.program} onChange={handleChange} className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900 bg-white" data-id="element-357">
                  <option value="" data-id="element-358">Select a program</option>
                  <option value="kids" data-id="element-359">Kids Taekwondo</option>
                  <option value="teen" data-id="element-360">Teen Taekwondo</option>
                  <option value="adult" data-id="element-361">Adult Taekwondo</option>
                  <option value="competition" data-id="element-362">
                    Competition / Team Training
                  </option>
                </select>
              </div>

              {/* Preferred Time (Optional) */}
              <div className="mb-6" data-id="element-363">
                <label htmlFor="preferredTime" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-364">
                  Preferred Class Time{' '}
                  <span className="text-neutral-500 text-xs font-normal" data-id="element-365">
                    (Optional)
                  </span>
                </label>
                <input type="text" id="preferredTime" name="preferredTime" value={formData.preferredTime} onChange={handleChange} placeholder="e.g., Weekday evenings, Saturday mornings" className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900" data-id="element-366" />
              </div>

              {/* Message (Optional) */}
              <div className="mb-8" data-id="element-367">
                <label htmlFor="message" className="block text-sm font-bold text-neutral-900 mb-2 uppercase tracking-wide" data-id="element-368">
                  Message / Questions{' '}
                  <span className="text-neutral-500 text-xs font-normal" data-id="element-369">
                    (Optional)
                  </span>
                </label>
                <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} placeholder="Any questions or additional information..." className="w-full px-4 py-3 border-2 border-neutral-200 rounded-sm focus:border-red-700 focus:outline-none transition-colors text-neutral-900 resize-none" data-id="element-370" />
              </div>

              {/* Submit Button */}
              <motion.button type="submit" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-red-700 text-white px-8 py-4 text-lg font-bold uppercase tracking-wide rounded-sm hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-red-700 focus:ring-offset-2 shadow-lg shadow-red-900/20 transition-colors" data-id="element-371">
                Submit My Signup
              </motion.button>

              {/* Microcopy */}
              <p className="text-center text-sm text-neutral-600 mt-4 font-medium" data-id="element-372">
                No contracts • No pressure • Fast response
              </p>
            </form>
          </motion.div>
        </div>
      </section>

      {/* Why Train With Us Section */}
      <section className="py-16 bg-white" data-id="element-373">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-374">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col lg:flex-row items-center gap-12" data-id="element-375">
            <div className="lg:w-1/2" data-id="element-376">
              <img src="https://images.unsplash.com/photo-1555597408-26bc8e548a46?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Taekwondo training" className="rounded-lg shadow-xl" data-id="element-377" />
            </div>
            <div className="lg:w-1/2" data-id="element-378">
              <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-379">
                Why Train With Our Taekwondo School
              </h2>
              <p className="text-lg text-neutral-600 leading-relaxed" data-id="element-380">
                Our Taekwondo school focuses on personal growth, discipline, and
                real skill development. Students train in a positive, structured
                environment that encourages confidence, respect, and
                perseverance. Families choose us because we care about long-term
                development, not quick results.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Location & Service Area Section */}
      <section className="py-16 bg-neutral-100" data-id="element-381">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-382">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-383">
            <div className="inline-flex items-center justify-center p-3 bg-red-100 rounded-full mb-6" data-id="element-384">
              <MapPin className="w-6 h-6 text-red-700" data-id="element-385" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-386">
              Serving Grapevine and Nearby Communities
            </h2>

            <p className="text-lg text-neutral-600 mb-8 leading-relaxed" data-id="element-387">
              Our school is conveniently located at Grapevine Mills, making it
              easy for families throughout the surrounding area to attend
              classes consistently.
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-388">
              {cities.map(city => <span key={city} className="px-3 py-1 bg-white border border-neutral-200 rounded-full text-sm font-medium text-neutral-600" data-id="element-389">
                  {city}
                </span>)}
            </div>

            <p className="text-lg font-medium text-neutral-800" data-id="element-390">
              If you are searching for Taekwondo classes near Grapevine, Texas,
              this is a great place to begin.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Final CTA Reminder Section */}
      <section className="py-20 bg-red-700 text-white" data-id="element-391">
        <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-392">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-393">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-394">
              Ready to Take the First Step?
            </h2>
            <p className="text-xl text-red-100" data-id="element-395">
              Complete the signup form above and our team will reach out shortly
              to help you get started.
            </p>
          </motion.div>
        </div>
      </section>
    </div>;
}